import { BaseService } from 'src/app/core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';

@Component({
  selector: 'app-sales-order-header-details-dialog',
  templateUrl: './sales-order-header-details-dialog.component.html',
  styleUrls: ['./sales-order-header-details-dialog.component.scss']
})
export class SalesOrderHeaderDetailsDialogComponent implements OnInit {
  form: FormGroup;
  trucks: {
    truckCode: string,
    truckDesc: string
  }[];

  constructor(
    public dialogRef: MatDialogRef<SalesOrderHeaderDetailsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {
    if (this.data.mode === 'SYSPRO') {
      this.form = fb.group({
        salesOrderNumber: [null, Validators.compose([])],
        alternateKey: [null, Validators.compose([Validators.maxLength(10)])],
        customerPoNumber: [null, Validators.compose([Validators.maxLength(30)])],
        shippingInstrs: [null, Validators.compose([Validators.maxLength(50)])],
        specialInstrs: [null, Validators.compose([Validators.maxLength(30)])],
        requestedShipDate: [null, Validators.compose([])],
        delayedDeliveryDat: [null, Validators.compose([])],
      });
    } else {
      this.form = fb.group({
        salesOrderHeaderId: [null, Validators.compose([])],
        specialInstrs: [null, Validators.compose([Validators.maxLength(30)])],
      });
    }
  }

  ngOnInit() {
    if (this.data.mode === 'SYSPRO') {
      this.baseService.executeCommand<any>('portal_syspro_order_order_details_dialog_config', this.data)
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.trucks = response.data.trucks;
            this.form.patchValue(this.data);
          }
        });
    } else {
      this.form.patchValue(this.data);
    }
  }

  save() {
    if (this.data.mode === 'SYSPRO') {
      const dialogData: OiGroupDialogData = {
        title: 'Updating Order Details In SYSPRO',
        function: 'portal_oi_group_syspro_order_details_modify',
        postBody: {
          ...this.form.getRawValue()
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('Order Details Updated In Syspro');
          this.dialogRef.close(true);
        }
      });
    } else {
      this.baseService.executeCommand<any>('portal_sales_order_header_details_modify', this.form.getRawValue())
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
    }
  }
}
